import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import forms from "./data/data-entry.json";

const DataEntryForm = (props) => {
  const { register, handleSubmit, reset } = useForm();

  const [formData, setFormData] = useState(forms[props.dataEntry.data_index]);

  useEffect(() => {
    if (props.view === "data_entry_test") {
      setFormData(
        JSON.parse(
          props.questions[props.dataEntry.data_index].reference_typing_text
        )
      );
    } else {
      setFormData(forms[props.dataEntry.data_index]);
    }
  }, [props.view, props.dataEntry.data_index, props.questions]);

  useEffect(() => {
    if (props.view === "data_entry_test") {
      handleUpdateDataEntryData();
    }
  }, [formData, props.view]);

  const onSubmit = (data) => {
    let rotation_count = props.dataEntry.rotation_count;
    let length = forms.length;
    if (props.view === "data_entry_test") {
      length = props.questions.length;
    }
    if (props.dataEntry.data_index + 1 === length) {
      rotation_count++;
    }
    props.nextDataEntryForm(rotation_count);
    reset();
  };

  const handleNextField = (event, index) => {
    props.is_typing_started();
    const keyPressed = event.key;
    if (keyPressed === "Enter") {
      event.preventDefault();
      let fieldIndex = index + 1;
      let key = null;
      let fieldInput = null;
      if (fieldIndex === formData.length) {
        handleSubmit(onSubmit)();
        fieldIndex = 0;
        key = formData[fieldIndex].key;
        props.resetTempDataEntryData();
      } else {
        key = formData[fieldIndex].key;
      }

      fieldInput = document.querySelector(`input[name="${key}"]`);
      fieldInput.focus(); // Move focus to the next input field
    }
  };

  const handleUpdateDataEntryData = () => {
    let form_index = props.dataEntry.form_index;
    props.updateDataEntryData(form_index, formData);
  };

  const handleChangeValue = (value, index) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData];
      const updatedObject = {
        ...updatedFormData[index],
        input: value,
      };
      updatedFormData[index] = updatedObject;
      return updatedFormData;
    });
  };

  const handleOnChangeField = (event, index) => {
    const { id, value } = event.target;
    props.setTempDataEntryData({
      ...props.temp_data_entry_data,
      [id]: value.replace(/'/g, "`").replace(/"/g, "``"),
    });
    handleChangeValue(value.replace(/'/g, "`").replace(/"/g, "``"), index);
  };

  const handleKeyPress = (event) => {
    if (event.key === "'" || event.key === '"') {
      event.preventDefault();
    }
  };

  const formContent = formData.map((item, index) => (
    <tr key={index}>
      <td>{item.fieldname}</td>
      <td>
        <input
          {...register(item.key)}
          type="text"
          className="form-control"
          id={item.key}
          name={item.key}
          defaultValue={props.temp_data_entry_data[item.key]}
          placeholder=""
          autoComplete="off"
          autoFocus={index === 0 ? true : false}
          onChange={(event) => {
            handleOnChangeField(event, index);
          }}
          onKeyDown={(event) => handleNextField(event, index)}
          onKeyPress={handleKeyPress}
          onFocus={(e) =>
            e.currentTarget.setSelectionRange(
              e.currentTarget.value.length,
              e.currentTarget.value.length
            )
          }
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
          onCopy={(e) => {
            e.preventDefault();
            return false;
          }}
        />
      </td>
    </tr>
  ));

  return (
    <form>
      <table className="table table-bordered">
        <tbody>{formContent}</tbody>
      </table>
    </form>
  );
};

export default DataEntryForm;
